/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SettlementDetailFooterActionsEnum {
    REJECT = 'REJECT',
    ACCEPT = 'ACCEPT'
}
